export default __webpack_public_path__ + "static/media/money-back.00550e6f.png";